module.exports = __webpack_public_path__ + "img/pdf.4c04fb09.jpg";